function getKeys(aHash) {
    "use strict";
    var lKey = null, lResult = [];
    if (!isNullOrUndefined(aHash)) {
        if (!isNullOrUndefined(Object.keys)) {
            lResult = Object.keys(aHash);
        } else {
            for (lKey in aHash) {
                if (aHash.hasOwnProperty(lKey)) {
                    lResult.push(lKey);
                }
            }
        }
    }
    return lResult;
}
function count(aList) {
    "use strict";
    var lKey = null,
        lResult = 0;

    if (!isNullOrUndefined(aList)) {
        if (!isNullOrUndefined(Object.keys)) {
            lResult = Object.keys(aList).length;
        } else {
            for (lKey in aList) {
                if (aList.hasOwnProperty(lKey)) {
                    lResult++;
                }
            }
        }
    }
    return lResult;
}
//function count(aList) {
//    "use strict";
//    var lKey = null,
//            lResult = 0;
//    if (!isNullOrUndefined(aList)) {
//        if (aList.constructor == Array) {
//            lResult = aList.length;
//        } else if (!isNullOrUndefined(Object.keys)) {
//            lResult = Object.keys(aList).length;
//        } else {
//            for (lKey in aList) {
//                if (aList.hasOwnProperty(lKey)) {
//                    lResult++;
//                }
//            }
//        }
//    }
//    return lResult;
//}
if (typeof exports !== 'undefined') {
    module.exports = {
        getKeys:getKeys,
        count:count
    };
}
